import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import { activePortalRegion } from './config/portal-regions';
import { ThemeProvider } from 'next-themes';
import { ThemeUpdater } from './components/ThemeUpdater';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import './index.css';
import { initializeZoho } from './utils/zoho-init';
import './config/aws-config'; // Initialize AWS configuration

initializeZoho();

const regionalTitle = `Simply Send — Email That Matters | ${activePortalRegion.label}`;
const regionalDescription = `Sign in to the Simply Send ${activePortalRegion.label} portal to manage your email delivery workspace.`;
const regionalCanonicalUrl = new URL('/', activePortalRegion.origin).href;
document.title = regionalTitle;
document.querySelector<HTMLMetaElement>('meta[name="description"]')?.setAttribute('content', regionalDescription);
document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.setAttribute('href', regionalCanonicalUrl);
document.querySelector<HTMLMetaElement>('meta[property="og:title"]')?.setAttribute('content', regionalTitle);
document.querySelector<HTMLMetaElement>('meta[property="og:description"]')?.setAttribute('content', regionalDescription);
document.querySelector<HTMLMetaElement>('meta[property="og:url"]')?.setAttribute('content', regionalCanonicalUrl);
document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]')?.setAttribute('content', regionalTitle);
document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]')?.setAttribute('content', regionalDescription);
document.querySelector<HTMLMetaElement>('meta[name="twitter:url"]')?.setAttribute('content', regionalCanonicalUrl);

// Create root and render app
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
          <AuthProvider>
            <ThemeUpdater />
            <App />
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
